<template>

  <div style="margin: auto" class="mb-3">

    <t-report-generate-dialog-routine-by-part v-if="dialogRoutineShow"
                                              :url="urlDownload"
                                              :server-onlaine-api="dialogRoutineServerOnlaineApi"
                                              :total-rows="dialogRoutineTotalRows"
                                              :total-parts="dialogRoutineTotalParts"
    />

    <t-form-card style="border:solid 1px #dddddd" :title="title" :help="help">

      <div v-if="onStatus === 'sending'"
           style="position: absolute; width: 100%; height: 100%; left: 0; z-index: 3; background-color: rgba(255,255,255,0.5)"
           class="d-flex justify-content-center">

        <transition name="fade">

          <div class="d-flex justify-content-center align-items-center p-5">

            <div class="loader">
              <div class="ball-spin-fade-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>


          </div>


        </transition>
      </div>


      <!--FICOU DIFICIL A INTERPRETAÇÃO NA MESMA TELA COM POPUP, POR ISSO DESABILITADA ESTA VISUALIZAÇÃO      -->
      <!--      <b-modal @ok="handleOk" ref="modalReport" size="xl" :title="title" scrollable no-close-on-esc
                     no-close-on-backdrop>
              <div class="report_container_data" id="section-to-print" v-html="reportHtml"></div>

              <template #modal-footer="{ ok, cancel }">

                <t-button @click="cancel()" class="mr-3" text="Fechar" outline-secondary/>
                <t-button @click="ok()" primary>
                  <b-icon-printer class="mr-2"/>
                  Imprimir
                </t-button>

              </template>

            </b-modal>-->

      <validation-observer ref="validation" v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

        <form @submit.prevent="onSubmit" action="" target="_blank" method="post" autocomplete="off"
              :class="{'form-loading':busy}" ref="form">

          <t-form-wrapped :status="onStatus">
            <slot :status="onStatus" :format="format"></slot>

            <div class="divider" v-if="enableSetting && showSetting"></div>

            <slot name="setting" v-if="enableSetting && showSetting" :status="onStatus"></slot>

            <div class="divider" v-if="enableSetting && showSetting"></div>


            <div class="pb-2" style="max-width: 600px" v-if="groupedPeriodOptions.length > 1 || formatOptions.length > 1">

              <b-row>

                <t-input v-if="groupedPeriodOptions.length > 1" cols="6" radio radio-button label="Agrupamento"
                         v-model="groupedPeriod" :options="groupedPeriodOptions"/>

                <t-input v-if="formatOptions.length > 1" cols="6" radio radio-button label="Formato" v-model="format"
                         :options="formatOptions"/>
              </b-row>

            </div>

            <div v-if="enabledTotalByPeriod" class="mb-2 ml-2 pb-2 pt-2 border-top">

              <b-form-checkbox v-model="totalByGrouped"
                               switch> Totalizar resultados por período
                <t-help :title=totalByPeriodHelp />
              </b-form-checkbox>

            </div>


          </t-form-wrapped>


          <div :class="{'report-actions-modal':modal,'report-actions-all-page':!modal}">


            <t-button light v-if="enableSetting" form-inline @click="showSetting = !showSetting"  class="mt-3 mr-2">
              <b-icon-gear class="mr-2"/>
              Configurações Adicionais
            </t-button>

            <t-button v-if="enableReportByPart && format !== 'html'" outline-primary form-inline submit-fake to="my-report"
                      class="mt-3 ml-2">
              <b-icon-card-heading class="mr-2"/>
              Histórico
            </t-button>

            <b-button variant="primary" @click="onSubmit" style="min-width: 300px" :sending="onSending" class="report-submit-button ml-3" >
              <b-icon-bar-chart class="mr-2" />
              Gerar {{ localButtonTitle }}
            </b-button>



          </div>


        </form>

      </validation-observer>

    </t-form-card>


  </div>


</template>
<script>

import functionsMixins from "@/mixins/page/functionsMixins";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";
import tReportGenerateDialogRoutineByPart from "@/components/template/theme/t-report-generate-dialog-routine-by-part";

export default {
  name: 't-report-generate',
  components: {tReportGenerateDialogRoutineByPart},
  mixins: [functionsMixins],
  data() {
    return {
      form: {},
      status: "",
      urlDownload: "",
      urlPrint: "",
      groupedPeriod: "",
      groupedPeriodOptions: [],
      format: "",
      formatOptions: [],
      reportHtml: "",
      totalByGrouped: false,
      dialogRoutineShow: false,
      dialogRoutineServerOnlaineApi: false,
      dialogRoutineTotalRows: 0,
      dialogRoutineTotalParts: 0,
      localButtonTitle: "",
      showSetting:false,
      localUrlChange:"",
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ""
    },
    buttonTitle: {
      type: String,
      default: ''
    },
    addErrorWord: {
      type: String,
      default: ""
    },
    urlChangeHtml: { /*Troca o link quando o formato é HTML */
      type: String,
      default: ""
    },
    /*Itens por padrão habilitados*/
    modal: Boolean,
    defaultPdf: Boolean,
    defaultExcel: Boolean,
    defaultWord: Boolean,
    enableGenerateHtml: Boolean,
    enableGeneratePdf: Boolean,
    enableGenerateExcel: Boolean,
    enableGenerateWord: Boolean,
    enableReportByPart: Boolean,
    enableSetting: Boolean,
    javaReport: Boolean,
    relationKey: {
      type: Number,
      default: 0
    },
    origin: {
      type: String,
      default: ""
    },
    /*----------------------------*/
    /*Itens por padrão desabilitados*/
    enableGroupedPeriod: Boolean,
    enabledTotalByPeriod: Boolean,
    totalByPeriodHelp: {
      type: String,
      default: 'Insere o totalizador de acordo com o tipo de agrupamento do período, exemplos: Diário, Mensal ou Anual.'
    },
    /*----------------------------*/
    value: {
      type: Object,
      required: true,
    },
    command: {
      type: String,
      default: 'insert'
    },
    landscape: Boolean,
    subValidationTag: String,
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
  },
  async mounted() {

    this.setValue(this.value)

    await this.onMountedDefault()

  },
  methods: {

    reportError(error) {

      this.status = "subject"

      if (error.response) {
        if (error.response.status === 500) {
          if (error.response.data) {
            if (error.response.data.message) {
              ui.msgError(this, 'Erro', error.response.data)
            } else {
              //console.log(error)
              ui.msgError(this, error.response.data.general[0])
            }
          }
        }
      } else if (error !== '') {
        ui.msgError(this, "Erro", error)
      }
    },

    setValue(v) {
      this.form = v
    },

    handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()

      window.open("/" + this.urlPrint)

      /*let myWindow = window.open('', 'PRINT', 'height=400,width=600');
      myWindow.document.write('<html><head><title>' + this.title + '</title>');
      myWindow.document.write("<link rel='stylesheet' media='all' type='text/css' href='https://custom.onlaine.com.br/assets/css/template.css'>")
      myWindow.document.write("<link rel='stylesheet' media='all' type='text/css' href='https://custom.onlaine.com.br/assets/css/bootstrap-vue.css'>")
      myWindow.document.write('</head><body >');
      myWindow.document.write('<h1>' + this.title + '</h1>');
      myWindow.document.write(this.reportHtml);
      myWindow.document.write('</body></html>');

      myWindow.document.close(); // necessary for IE >= 10
      myWindow.focus(); // necessary for IE >= 10*!/

      myWindow.print();
      myWindow.close();*/

    },

    async onMountedDefault() {

      this.groupedPeriodOptions = []
      this.formatOptions = []

      if (this.buttonTitle !== '') {
        this.localButtonTitle = this.buttonTitle
      } else {
        this.localButtonTitle = this.title
      }

      if (this.enableGroupedPeriod) {

        //Agrupamento padrão de período, no futuro poderá ter diferentes ou mesmo excluir algum tipo.
        this.groupedPeriodOptions.push({value: "D", text: "Diário"})
        this.groupedPeriodOptions.push({value: "M", text: "Mensal"})
        this.groupedPeriodOptions.push({value: "Y", text: "Anual"})

        //O padrão será o primeiro da listagem
        this.groupedPeriod = this.groupedPeriodOptions[0].value

      }

      if (this.enableGenerateHtml) {
        this.formatOptions.push({value: "html", text: "Visualizar"})
      }

      if (this.enableGenerateExcel) {
        this.formatOptions.push({value: "xls", text: "Excel"})
      }

      if (this.enableGeneratePdf) {
        this.formatOptions.push({value: "pdf", text: "PDF"})
      }

      if (this.enableGenerateWord) {
        this.formatOptions.push({value: "docx", text: "Word"})
      }

      //O padrão será o primeiro da listagem
      if (this.defaultPdf) {
        this.format = "pdf"
      } else if (this.defaultExcel) {
        this.format = "xls"
      } else if (this.defaultWord) {
        this.format = "docx"
      } else {
        this.format = this.formatOptions[0].value
      }


    },

    async onSubmit() {

      //Avisa o pai que mudou o status para submetido
      this.status = "subject"

      this.$refs.validation.validate().then(async success => {

        if (!success) {
          return;
        }

        if (this.addErrorWord !== '' && this.format === 'docx') {
          ui.msgError(this, this.addErrorWord)
          return;
        }

        //URL para geração
        this.urlDownload = "general/report/generate?platform=web&origin=" + this.origin + "&subValidationTag=" + this.subValidationTag + "&type=R&format=" + this.format + "&groupedPeriod=" + this.groupedPeriod + "&totalByGrouped=" + this.totalByGrouped + "&relationKey=" + this.relationKey + "&title=" + encodeURI(this.title)


        //URL em caso de impressão de HTML
        this.urlPrint = "report-view/?landscape=" + this.landscape + "&subValidationTag=" + this.subValidationTag + "&groupedPeriod=" + this.groupedPeriod + "&totalByGrouped=" + this.totalByGrouped + "&title=" + encodeURI(this.title)

        //URL para envio
        this.localUrlChange = this.urlChangeHtml

        let params = new URLSearchParams()

        Object.keys(this.form).forEach(key => {

          if (this.form[key] !== '' && this.form[key] !== 0) {
            //console.log(key, this.form[key])
            params.append(key, this.form[key])
          }

        })

        if (params && Array.from(params).length > 0) {
          this.urlDownload += `&${params}`
          this.urlPrint += `&${params}`
          this.localUrlChange += `&${params}`
        }

        if (this.enableReportByPart && this.format !== 'html') {
          //Formato novo utilizando o próprio back-end
          this.status = "subject"
          this.dialogRoutineShow = true
          this.dialogRoutineServerOnlaineApi = true
          this.dialogRoutineTotalRows = 0
          this.dialogRoutineTotalParts = 0
          this.openModal('modal-report-dialog-routine-by-part')

          return;
        }

        this.status = "sending"

        if (this.format === 'html') {

          //Abre em nova janela para nesta sim realizar o get e exibir

          //console.log(this.localUrlChange)


          if(this.urlChangeHtml.length > 0) {
            this.localUrlChange = (this.localUrlChange || "").replace(/^\/+/, "")
            window.open("/" + this.localUrlChange)
          }else{
            window.open("/" + this.urlPrint)
          }

          this.status = "subject"

        } else if (this.format === 'pdf' || this.format === 'xls' || this.format === 'docx') {

          let nameFile = ui.nameFile(this.title, this.format)

          //Correção para Excel mais moderno para este tipo de relatório
          if (this.javaReport) {
            if (this.format === 'xls') {
              nameFile = ui.nameFile(this.title, 'xlsx')
            }
          }

          await http.download(this.urlDownload, nameFile).then(() => {
            this.status = "subject"
          }).catch(error => {

            const b = new Blob([error.response.data], {type: "application/json"}),
                fr = new FileReader();

            fr.onload = e => {

              const objectError = JSON.parse(e.target.result)

              if (error.response.status === 500) {
                this.status = "subject"
                ui.msgError(this, objectError.general[0])
              } else if (error.response.status === 610) {

                //Formato antigo utilizando o ASP como relatórios avançados por partes
                this.status = "subject"
                this.dialogRoutineShow = true
                this.dialogRoutineServerOnlaineApi = false
                this.dialogRoutineTotalRows = objectError.totalRows
                this.dialogRoutineTotalParts = objectError.totalParts
                this.openModal('modal-report-dialog-routine-by-part')

              }


            }

            fr.readAsText(b);


          })

        }

      })

    },

  },
  computed: {
    onStatus() {
      return this.status
    },
    onSending() {
      return this.status === "sending"
    },
  },
  watch: {
    value(v) {
      this.setValue(v)
    },
    form(v) {
      this.$emit("input", v)
    },
    /*defaultExcel(){
      this.onMountedDefault()
    },
    defaultPdf(){
      this.onMountedDefault()
    },
    defaultWord(){
      this.onMountedDefault()
    },
    enableGenerateWord(){
      this.onMountedDefault()
    },
    enableGeneratePdf(){
      this.onMountedDefault()
    },
    enableGenerateExcel(){
      this.onMountedDefault()
    }*/
  }
}
</script>
